// core
import { Injectable } from '@angular/core';

// services
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerService extends ApiService {

  details(): Promise<any> {
    return this.get('/v2/customer').toPromise();
  }

  update(payload: any): Promise<any> {
    return this.post('/v2/customer', payload).toPromise();
  }
}
